// extracted by mini-css-extract-plugin
export default {"bigpage":"Bigpage_bigpage__qgcFA","container":"Bigpage_container__2X1GA","image":"Bigpage_image__bVe5Y"};